export default class EventAggregator {
  id: string;

  description: string;

  lastDate: Date;

  originSystem: string;

  pendingError: number;

  latestErrorContext: string;

  latestErrorId: string;

  constructor(obj: any) {
    this.id = obj.id || '';
    this.description = obj.description || '';
    this.lastDate = obj.lastDate || '';
    this.originSystem = obj.originSystem || '';
    this.pendingError = obj.pendingError || '';
    this.latestErrorContext = obj.latestErrorContext || '';
    this.latestErrorId = obj.latestErrorId || '';
  }

  public static of(value: any): EventAggregator {
    return new EventAggregator(value || {});
  }

  public static ofList(response: any): EventAggregator[] {
    return response.data.map(this.of);
  }
}
